import { useToast } from '#providers/ToastProvider';
import { useEffect, useMemo, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useUploadFiles } from 'src/shared/components/file-upload/useFileUpload';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import { getWindowHeight } from '../lib/getWindowHeight';

const ReactQuillEditor = ({
  registerName,
  placeholder = '내용을 입력해주세요.'
}: {
  registerName: string;
  placeholder?: string;
}) => {
  const height = getWindowHeight(130);

  const { showToast } = useToast();
  const { setValue, getValues, control } = useFormContext();
  const watcher = useWatch({ control, name: registerName });

  const quillRef = useRef(null);

  const { uploadFiles: uploadFilesToS3 } = useUploadFiles();

  const imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();
    input.onchange = async () => {
      const file = input.files;

      if (file && file.length > 0) {
        const arrayfiyFiles = Array.from(file);
        await uploadFilesToS3({
          selectedFiles: arrayfiyFiles,
          path: 'image',
          onError: () => {
            showToast({
              type: 'fail',
              message: '이미지 업로드에 실패했습니다.'
            });
          },
          onSuccess: value => {
            if (quillRef.current) {
              const quillObj = (quillRef.current as ReactQuill).getEditor();
              const range = quillObj.getSelection();
              if (range) {
                quillObj.insertEmbed(range.index, 'image', value.imgUrl);

                setValue(registerName, quillObj.root.innerHTML);
                if (!getValues('imageId')) {
                  setValue('imageId', value.id);
                }
                quillObj.setSelection({ ...range, index: range.index + 1 });
              }
            }
          }
        });
      }
    };
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [['bold'], [{ list: 'ordered' }], ['image']],
        handlers: { image: imageHandler }
      },
      clipboard: {
        matchVisual: false
      }
    }),
    []
  );

  useEffect(() => {
    if (quillRef.current) {
      (quillRef.current as ReactQuill).getEditor().root.dataset.placeholder =
        placeholder || '내용을 입력해주세요.';
    }
  }, [quillRef, placeholder]);

  return (
    <div className="custom-quill">
      <ReactQuill
        className={`border-0 ${height} pt-22`}
        ref={quillRef}
        value={watcher}
        onChange={value => setValue(registerName, value)}
        modules={modules}
        placeholder={placeholder}
      />
    </div>
  );
};

export default ReactQuillEditor;
